import Vue from 'vue';
import VueI18n from 'vue-i18n';
import {defaultLocale, messages} from '../lang';
import axios from 'axios';

Vue.use(VueI18n);

export const i18n = new VueI18n({
    locale: defaultLocale,
    fallbackLocale: defaultLocale,
    messages,
});

export function setI18nLanguage(lang) {
    i18n.locale = lang;
    axios.defaults.headers.common['Accept-Language'] = lang;
    document.querySelector('html').setAttribute('lang', lang);

    return lang;
}
